module.exports = __webpack_public_path__ + "Flaticon.f72604735e9c09d6a1e3.eot";


//////////////////
// WEBPACK FOOTER
// /Users/tabelini/development/jvm/tenacity/pysix/PysixCloud/src/fonts/Flaticon.eot
// module id = ../../../../../src/fonts/Flaticon.eot
// module chunks = styles